export enum Estado {
  Login = 0,
  Canje = 1,
  OTP = 2,
  Success = 3,
  Error = 4,
  StopEvent = 5,
}
